module.exports = __webpack_public_path__ + "static/assets/55e835621ad012682f5094922f5deaf4.png";